module.exports = __webpack_public_path__ + "static/media/jp.6de1711c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/jp.svg
// module id = 2126
// module chunks = 0